<template>
  <v-card style="height: 400px;">
    <v-card-title class="pb-0">
      Rooms
      <v-icon v-if="!loading" @click="loadItems()">mdi-refresh</v-icon>
    </v-card-title>

    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>

    <v-card-text style="height:320px;overflow-y:auto">
      <v-list v-if="items.length">
        <v-list-item
          v-for="item in items"
          :key="item.id"
          dense
          style="border-bottom: 1px solid #ddd !important"
          class="px-0"
        >
          <v-list-item-content>
            <v-list-item-title class="d-flex justify-space-between">
              <span :class="item.isOccupied ? 'red--text' : ''">{{ item.name_eng }}</span>
              <v-icon x-small :color="item.isOccupied ? 'red' : 'green'">
                mdi-circle
              </v-icon>
            </v-list-item-title>
            <v-list-item-subtitle></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <div
        v-else-if="!loading"
        class="d-flex justify-center align-center grey--text"
        style="height: 320px"
      >
        No rooms..
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    items: [],
  }),
  methods: {
    loadItems() {
      this.loading = true
      this.$axios
        .get(`/api/rooms?schedulable=true&available_now=true`)
        .then(res => {
          this.items = res.data
        })
        .finally(_ => (this.loading = false))
    },
  },
  mounted() {
    this.loadItems()
  },
}
</script>